// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navbar {
    /*z-index: 5;*/
}
.navbar > div {
    justify-content: space-between;
}

.navbar div.nav-bar-right  div.menu-circle  > li.pi:hover,
.navbar div.nav-bar-right > div > li.pi:hover {
    background: rgb(75, 196, 236, 0.31);
    opacity: 1 !important;
    transition: 0.3s;
}

.navbar .menu-dropdown {
    left: -108px;
    width: 280px;
    background-color: var(--blue-dark);
    color: white;
    border: 1px solid white;
    border-radius: 15px;
}


.navbar .language-selector select.language-dropdown{
    color: var(--blue);
    appearance: none;
    background-color: transparent;
    border: none;
    padding: 0 1em 0 0;
    margin: 0;
    width: 100%;
    font-family: inherit;
    font-size: inherit;
    cursor: inherit;
    line-height: inherit;
    outline: none;
    opacity: 0.8;
}
.navbar .language-selector select.language-dropdown:hover{
    text-decoration: underline;
    opacity: 1 !important;
    transition: 0.3s;
}

.navbar .language-selector select.language-dropdown *{
    background-color: var(--blue-dark);
    border: none;
}

.navbar .circle-menu svg{
    position: absolute;
    width: 34px;
    left: 15px;
    z-index: 9;
}

@media (max-width: 1024px) {
    .navbar .nav-bar-left > div{
        display: none !important;
    }
}
@media (max-width: 650px) {
    .navbar .nav-bar-left > div{
        display: none !important;
    }
    .navbar .menu-dropdown {
        width: 220px;
        left: -60px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/navbar.css"],"names":[],"mappings":";AACA;IACI,cAAc;AAClB;AACA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,mCAAmC;IACnC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,YAAY;QACZ,WAAW;IACf;AACJ","sourcesContent":["\n.navbar {\n    /*z-index: 5;*/\n}\n.navbar > div {\n    justify-content: space-between;\n}\n\n.navbar div.nav-bar-right  div.menu-circle  > li.pi:hover,\n.navbar div.nav-bar-right > div > li.pi:hover {\n    background: rgb(75, 196, 236, 0.31);\n    opacity: 1 !important;\n    transition: 0.3s;\n}\n\n.navbar .menu-dropdown {\n    left: -108px;\n    width: 280px;\n    background-color: var(--blue-dark);\n    color: white;\n    border: 1px solid white;\n    border-radius: 15px;\n}\n\n\n.navbar .language-selector select.language-dropdown{\n    color: var(--blue);\n    appearance: none;\n    background-color: transparent;\n    border: none;\n    padding: 0 1em 0 0;\n    margin: 0;\n    width: 100%;\n    font-family: inherit;\n    font-size: inherit;\n    cursor: inherit;\n    line-height: inherit;\n    outline: none;\n    opacity: 0.8;\n}\n.navbar .language-selector select.language-dropdown:hover{\n    text-decoration: underline;\n    opacity: 1 !important;\n    transition: 0.3s;\n}\n\n.navbar .language-selector select.language-dropdown *{\n    background-color: var(--blue-dark);\n    border: none;\n}\n\n.navbar .circle-menu svg{\n    position: absolute;\n    width: 34px;\n    left: 15px;\n    z-index: 9;\n}\n\n@media (max-width: 1024px) {\n    .navbar .nav-bar-left > div{\n        display: none !important;\n    }\n}\n@media (max-width: 650px) {\n    .navbar .nav-bar-left > div{\n        display: none !important;\n    }\n    .navbar .menu-dropdown {\n        width: 220px;\n        left: -60px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
